/**
 * Different types of Title level.
 * @public
 */
enum TitleLevel {
	/**
	 * Renders `h1` tag.
	 * @public
	 */
	H1 = "H1",

	/**
	 * Renders `h2` tag.
	 * @public
	 */
	H2 = "H2",

	/**
	 * Renders `h3` tag.
	 * @public
	 */
	H3 = "H3",

	/**
	 * Renders `h4` tag.
	 * @public
	 */
	H4 = "H4",

	/**
	 * Renders `h5` tag.
	 * @public
	 */
	H5 = "H5",

	/**
	 * Renders `h6` tag.
	 * @public
	 */
	H6 = "H6",
}

export default TitleLevel;
